/* Speed Army - Rim Strip Editor: "Create your own" mode.
 * Re-creates the Photoshop mockup chain for any text: the flat strip artwork
 * (dashes + text) is bent with the Arc warp, then pushed through each strip's
 * 4x4 Bezier envelope onto the wheel. Geometry comes from sa-rim-custom.json
 * (scripts/sa-rim-custom-geom.py). Loaded only when the section enables it.
 */
(function () {
  'use strict';
  var E = window.SARimEditor;
  if (!E) return;
  var P = E.prototype;
  var STRIP_SCALE = 1.5;   // straight strip rasterised at 1.5x (3789px): crisp text, under Safari's 4096px canvas limit
  var MAX_CHARS = 16;

  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  P.initCustom = function () {
    var self = this, cfg = this.cfg;
    if (this.custom || !cfg.customUrl || !q(this.root, '[data-sa-mode]')) return;
    this.state.mode = 'model';
    this.state.text = (cfg.customDefault || 'SPEED ARMY').toUpperCase();
    this.custom = { fonts: cfg.customFonts || [], geom: null, shade: null };
    this.state.font = this.custom.fonts.length ? this.custom.fonts[0].family : 'sans-serif';
    var textInput = q(this.root, '[data-sa-text]'), fontSel = q(this.root, '[data-sa-font]');
    if (textInput) {
      textInput.value = this.state.text;
      textInput.addEventListener('input', function () {
        self.state.text = textInput.value.toUpperCase().replace(/[^A-Z0-9 .\-&']/g, '').slice(0, MAX_CHARS);
        if (textInput.value !== self.state.text) textInput.value = self.state.text;
        self.sync(); self.renderSoon();
      });
    }
    if (fontSel) {
      fontSel.innerHTML = this.custom.fonts.map(function (f) { return '<option value="' + f.family + '">' + f.family + '</option>'; }).join('');
      fontSel.addEventListener('change', function () { self.state.font = fontSel.value; self.loadFont().then(function () { self.sync(); self.render(); }); });
    }
    qa(this.root, '[data-sa-mode]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) self.setMode(r.value); });
    });
    fetch(cfg.customUrl).then(function (r) { return r.json(); }).then(function (g) {
      self.custom.geom = g;
      return new Promise(function (res) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = cfg.shadeUrl; });
    }).then(function (im) { self.custom.shade = im; if (self.state.mode === 'custom') self.render(); });
    this.setMode('model');
  };

  P.setMode = function (mode) {
    var self = this, custom = mode === 'custom';
    this.state.mode = mode;
    qa(this.root, '[data-sa-mode]').forEach(function (r) {
      r.checked = r.value === mode;
      var lab = r.closest('.sa-rim__mode'); if (lab) lab.classList.toggle('is-on', r.checked);
    });
    var fields = q(this.root, '[data-sa-custom-fields]'), modelGroup = q(this.root, '[data-sa-model-group]');
    if (fields) fields.hidden = !custom;
    if (modelGroup) modelGroup.hidden = custom;
    qa(this.root, '[data-sa-text], [data-sa-font]').forEach(function (el) { el.disabled = !custom; });
    if (custom) this.loadFont().then(function () { self.sync(); self.render(); }); else { this.sync(); this.render(); }
  };

  P.loadFont = function () {
    var f = this.fontFor(this.state.font);
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load(fontSpec(f, 100)).catch(function () {});
  };

  /* CSS font shorthand for a font entry {family, weight}; weight defaults to 700 */
  function fontSpec(f, size) {
    return (f.weight || 700) + ' ' + size + 'px "' + f.family + '"';
  }

  P.renderSoon = function () {
    var self = this;
    clearTimeout(this._t);
    this._t = setTimeout(function () { self.render(); }, 120);
  };

  P.fontFor = function (fam) {
    return this.custom.fonts.filter(function (f) { return f.family === fam; })[0] || { family: fam, weight: 700, skew: 0.2 };
  };

  /* Fit text: font size from cap height, optional shrink to a maximum width. */
  function fitText(ctx, f, text, capH, maxW) {
    ctx.font = fontSpec(f, 100);
    var cap = ctx.measureText('H').actualBoundingBoxAscent || 72;
    var size = 100 * capH / cap;
    ctx.font = fontSpec(f, size);
    var w = ctx.measureText(text).width;
    if (w > maxW) { size *= maxW / w; ctx.font = fontSpec(f, size); w = maxW; }
    return { size: size, width: w };
  }

  function drawSkewedText(ctx, text, cx, baseline, capH, skew, weight) {
    var w = ctx.measureText(text).width;
    ctx.save();
    ctx.setTransform(1, 0, -skew, 1, cx + skew * capH / 2, baseline);
    ctx.textBaseline = 'alphabetic';
    // the vinyl lettering is bold: regular faces get a strong emboldening stroke, bold cuts a light one
    var heavy = parseInt(weight, 10) >= 700;
    ctx.lineJoin = 'round'; ctx.lineWidth = capH * (heavy ? 0.025 : 0.07); ctx.strokeStyle = ctx.fillStyle;
    ctx.strokeText(text, -w / 2, 0);
    ctx.fillText(text, -w / 2, 0);
    ctx.restore();
  }

  /* Straight strip: all eight dashes exactly as the standard kit, text fitted into the gap. */
  P.stripCanvas = function () {
    var g = this.custom.geom, st = g.strip, k = STRIP_SCALE, f = this.fontFor(this.state.font);
    var c = this.stripC || (this.stripC = document.createElement('canvas'));
    c.width = st.w * k; c.height = st.h * k;
    var ctx = c.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, c.width, c.height); ctx.fillStyle = '#000';
    var capH = (st.textBox[3] - st.textBox[1]) * k, baseline = st.textBox[3] * k, mid = st.w / 2;
    var text = this.state.text || ' ';
    var gapL = 0, gapR = c.width;
    st.dashes.forEach(function (d) {
      var lo = Math.min(d.top[0], d.bot[0]) * k, hi = Math.max(d.top[1], d.bot[1]) * k;
      if (hi <= mid * k) gapL = Math.max(gapL, hi); else gapR = Math.min(gapR, lo);
    });
    var pad = 12 * k;
    fitText(ctx, f, text, capH, gapR - gapL - 2 * pad);
    st.dashes.forEach(function (d) {
      ctx.beginPath();
      ctx.moveTo(d.top[0] * k, d.y0 * k); ctx.lineTo(d.top[1] * k, d.y0 * k);
      ctx.lineTo(d.bot[1] * k, d.y1 * k); ctx.lineTo(d.bot[0] * k, d.y1 * k); ctx.closePath(); ctx.fill();
    });
    drawSkewedText(ctx, text, c.width / 2, baseline, capH, f.skew == null ? 0.2 : f.skew, f.weight);
    return c;
  };

  /* Inner-rim decal: the text alone in the decal's source box. */
  P.insideCanvas = function () {
    var g = this.custom.geom, L = g.layers.inside, f = this.fontFor(this.state.font);
    var c = this.insideC || (this.insideC = document.createElement('canvas'));
    c.width = L.src[0]; c.height = L.src[1];
    var ctx = c.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, c.width, c.height); ctx.fillStyle = '#000';
    var tb = L.textBox, capH = tb[3] - tb[1];
    fitText(ctx, f, this.state.text || ' ', capH, tb[2] - tb[0]);
    drawSkewedText(ctx, this.state.text || ' ', (tb[0] + tb[2]) / 2, tb[3], capH, f.skew == null ? 0.2 : f.skew, f.weight);
    return c;
  };

  /* --- geometry ------------------------------------------------------- */
  function bern(t) { var u = 1 - t; return [u * u * u, 3 * t * u * u, 3 * t * t * u, t * t * t]; }
  function surface(L, s, t) {
    var Bs = bern(s), Bt = bern(t), x = 0, y = 0;
    for (var j = 0; j < 4; j++) for (var i = 0; i < 4; i++) { var w = Bs[i] * Bt[j]; x += w * L.meshH[j * 4 + i]; y += w * L.meshV[j * 4 + i]; }
    return [x, y];
  }
  P.toFrame = function (L, s, t, dx, dy) {
    var g = this.custom.geom, p = surface(L, s, t), M = L.M, k = g.frame[0] / g.doc[0];
    return [(M[0][0] * p[0] + M[0][1] * p[1] + M[0][2] + (dx || 0)) * k, (M[1][0] * p[0] + M[1][1] * p[1] + M[1][2] + (dy || 0)) * k];
  };
  /* straight strip pixel (in 1x strip units) -> Arc warp -> layer envelope -> frame,
     plus the per-strip quadratic correction fitted against Photoshop's render */
  P.mapStrip = function (L, x, y) {
    var g = this.custom.geom, a = g.arc, st = g.strip;
    var th = -Math.PI / 2 + (x / st.w - 0.5) * a.dth, r = a.R - a.k * (y - st.h / 2);
    var ax = a.cx + r * Math.cos(th), ay = a.cy + r * Math.sin(th);
    var dx = 0, dy = 0;
    if (L.corr) {
      var u = x / st.w, v = y / st.h, F = [1, u, v, u * u, u * v, v * v];
      for (var i = 0; i < 6; i++) { dx += L.corr.x[i] * F[i]; dy += L.corr.y[i] * F[i]; }
    }
    return this.toFrame(L, ax / a.w, ay / a.h, dx, dy);
  };

  function drawTri(ctx, img, s0, s1, s2, d0, d1, d2) {
    var ax = s1[0] - s0[0], ay = s1[1] - s0[1], bx = s2[0] - s0[0], by = s2[1] - s0[1];
    var det = ax * by - ay * bx; if (!det) return;
    var cx = d1[0] - d0[0], cy = d1[1] - d0[1], dx = d2[0] - d0[0], dy = d2[1] - d0[1];
    var a = (cx * by - dx * ay) / det, b = (cy * by - dy * ay) / det, c = (dx * ax - cx * bx) / det, d = (dy * ax - cy * bx) / det;
    var e = d0[0] - a * s0[0] - c * s0[1], f = d0[1] - b * s0[0] - d * s0[1];
    // grow the clip by ~1.5px away from the centroid so antialiased edges overlap and no seams show
    var gx = (d0[0] + d1[0] + d2[0]) / 3, gy = (d0[1] + d1[1] + d2[1]) / 3;
    function out(p) { var vx = p[0] - gx, vy = p[1] - gy, n = Math.sqrt(vx * vx + vy * vy) || 1; return [p[0] + vx / n * 1.5, p[1] + vy / n * 1.5]; }
    var p0 = out(d0), p1 = out(d1), p2 = out(d2);
    ctx.save(); ctx.beginPath();
    ctx.moveTo(p0[0], p0[1]); ctx.lineTo(p1[0], p1[1]); ctx.lineTo(p2[0], p2[1]);
    ctx.closePath(); ctx.clip(); ctx.setTransform(a, b, c, d, e, f); ctx.drawImage(img, 0, 0); ctx.restore();
  }

  /* Warp a source canvas onto ctx through mapFn(u,v)->[x,y] using a cols x rows grid. */
  function drawWarped(ctx, src, cols, rows, mapFn) {
    var W = src.width, H = src.height, grid = [];
    for (var j = 0; j <= rows; j++) { grid[j] = []; for (var i = 0; i <= cols; i++) grid[j][i] = mapFn(i / cols, j / rows); }
    for (j = 0; j < rows; j++) for (i = 0; i < cols; i++) {
      var sx0 = i / cols * W, sx1 = (i + 1) / cols * W, sy0 = j / rows * H, sy1 = (j + 1) / rows * H;
      drawTri(ctx, src, [sx0, sy0], [sx1, sy0], [sx0, sy1], grid[j][i], grid[j][i + 1], grid[j + 1][i]);
      drawTri(ctx, src, [sx1, sy0], [sx1, sy1], [sx0, sy1], grid[j][i + 1], grid[j + 1][i + 1], grid[j + 1][i]);
    }
  }

  P.renderCustom = function (ctx, W, H) {
    var self = this, g = this.custom.geom;
    if (!g) return;
    var strip = this.stripCanvas(), inside = this.insideCanvas(), st = g.strip;
    var masks = { main: this.maskCanvas('main', W, H), secondary: this.maskCanvas('secondary', W, H), inside: this.maskCanvas('inside', W, H) };
    Object.keys(g.layers).forEach(function (name) {
      var L = g.layers[name], mctx = masks[L.zone].getContext('2d');
      if (name === 'inside') {
        drawWarped(mctx, inside, 48, 4, function (u, v) { return self.toFrame(L, u, v); });
      } else {
        drawWarped(mctx, strip, 110, 3, function (u, v) { return self.mapStrip(L, u * st.w, v * st.h); });
      }
    });
    ctx.drawImage(this.tint(masks.main, this.colour(this.state.main).hex, false), 0, 0);
    ctx.drawImage(this.tint(masks.secondary, this.colour(this.state.secondary).hex, false), 0, 0);
    if (this.state.insideOn) ctx.drawImage(this.tintShaded(masks.inside, this.colour(this.state.inside).hex, W, H), 0, 0);
  };

  P.maskCanvas = function (key, W, H) {
    this.masks = this.masks || {};
    var c = this.masks[key] || (this.masks[key] = document.createElement('canvas'));
    c.width = W; c.height = H;
    return c;
  };

  /* Tint the decal, then apply the rim shading (luminosity, 27%) through its alpha. */
  P.tintShaded = function (mask, hex, W, H) {
    var g = this.custom.geom, tinted = this.tint(mask, hex, false);
    var out = this.shadedC || (this.shadedC = document.createElement('canvas'));
    out.width = W; out.height = H;
    var o = out.getContext('2d');
    o.drawImage(tinted, 0, 0);
    if (this.custom.shade) {
      var sh = this.maskCanvas('_shade', W, H), s = sh.getContext('2d');
      s.globalCompositeOperation = 'source-over'; s.drawImage(this.custom.shade, 0, 0, W, H);
      s.globalCompositeOperation = 'destination-in'; s.drawImage(mask, 0, 0);
      o.globalCompositeOperation = 'luminosity'; o.globalAlpha = g.shadeAlpha || 0.27;
      o.drawImage(sh, 0, 0);
      o.globalAlpha = 1; o.globalCompositeOperation = 'source-over';
    }
    return out;
  };

  // The core script may already have built its controls before this file finished
  // downloading (its model index is small and cached); attach to those editors now.
  qa(document, '[data-sa-rim]').forEach(function (root) {
    if (root.saRim && root.saRim.index) root.saRim.initCustom();
  });
})();
